import { gql } from "@apollo/client";

export const partners = gql`
  query ($where: JSON, $sort: String) {
    partners(where: $where, sort: $sort) {
      id
      title
      label
      locale
      slug
      private
      verified {
        verified
      }
      thumbnail {
        id
        name
        url
        formats
      }
      discounts {
        id
        value
        group
      }
      tags {
        id
        name
      }
    }
  }
`;
